(() => {
  const configNode = document.getElementById('sm-closure-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const closed = config.closed || {};
  const automaticBlackbook = config.autoBlackbook === true;
  if (automaticBlackbook) closed.blackbook = false;
  const originalAttributes = new WeakMap();
  const trackedAttributes = ['href','target','download','title','aria-label','aria-expanded'];
  const home = new URL(config.home || '/', location.origin);
  const normalize = value => String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
  const extraLabels = new Set(String(config.labels || '').split(/\r?\n/).map(normalize).filter(Boolean));
  const rules = [
    ['blackbook', ['/pages/blackbooks'], '.sm-home-blackbook-toggle,.sm-whatwrite-action', /^(whatyouwrite|blackbook)/],
    ['database', ['/pages/database'], null, /^writerdatabase$/],
    ['stickers', ['/pages/live-stickers'], '.smx-top-live-tab', /^(needstickers|livecustomstickers|livestickers)$/],
    ['clothing', ['/pages/live-custom-clothing','/pages/atm-clean','/pages/live-clothing'], '.sm-home-clothing-toggle', /^(customclothing|livecustomclothing)$/],
    ['handdrawn', ['/collections/hand-drawn-stickers'], '.smx-handdrawn-top-lane>a', /^(handdrawnslaps|handdrawnstickers)$/],
    ['vinyls', ['/collections/artist-vinyls'], '.smx-artist-vinyl-top-lane>a', /^(vinylsthatslap|artistvinyls)$/],
    ['art', ['/collections/graffiti-works'], '.smx-original-art-top-lane>a', /^(graffitiworks|originalart|artwork)$/],
    ['prints', ['/collections/prints-1'], '.smx-prints-top-lane>a', /^prints$/],
    ['tunnel', ['/collections/tunnel-rats'], '.smx-tunnel-top-lane>a', /^tunnelrats$/],
    ['apparel', ['/collections/shirts'], null, /^apparel$/],
    ['objects', ['/collections/3d-objects','/collections/objects'], null, /^(objects3d|3dobjects)$/],
    ['learn', ['/pages/learn','/pages/books-learn'], '[data-sm-books-learn]', /^(bookslearnarchive|bookslearn)$/]
  ];
  const pathMatches = (path, prefix) => path === prefix || path.startsWith(prefix + '/');
  const blackbookURL = url => url.hostname === 'stylemechanics-community-production.up.railway.app' ||
    url.origin === location.origin && (pathMatches(url.pathname, '/pages/blackbooks') ||
    pathMatches(url.pathname, '/pages/database') || /blackbook/i.test(url.hash) ||
    url.searchParams.has('writer'));
  const routeClosed = url => closed.blackbook && blackbookURL(url) || rules.some(([key, paths]) =>
    closed[key] && url.origin === location.origin && paths.some(path => pathMatches(url.pathname, path)));
  const current = new URL(location.href);
  if (routeClosed(current)) {
    if (current.searchParams.has('preview_theme_id')) home.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    location.replace(home.href);
    return;
  }
  const matches = element => {
    const label = normalize((element.querySelector('.lane-label,.sm-catbar__label') || element).textContent);
    if (extraLabels.has(label) || extraLabels.has(normalize(originalAttributes.get(element)?.['aria-label'] ?? element.getAttribute('aria-label'))) ||
      Array.from(element.querySelectorAll('.lane-label,b,strong,h2,h3')).some(part => extraLabels.has(normalize(part.textContent)))) return true;
    const href = element.dataset.smClosureOriginalHref || element.getAttribute('href');
    if (href) {
      try { if (routeClosed(new URL(href, location.href))) return true; } catch (_) {}
    }
    return rules.some(([key, , selector, pattern]) => closed[key] &&
      (selector && element.matches(selector) || pattern.test(label)));
  };
  const mark = element => {
    if (!matches(element)) {
      const original = originalAttributes.get(element);
      if (original) {
        trackedAttributes.forEach(name => original[name] === null ? element.removeAttribute(name) : element.setAttribute(name, original[name]));
        element.removeAttribute('data-sm-closed');
        element.removeAttribute('data-sm-closed-label');
        element.removeAttribute('data-sm-closure-original-href');
        if (!original.hadClosedClass) element.classList.remove('sm-is-closed');
        originalAttributes.delete(element);
      }
      return false;
    }
    if (!element.hasAttribute('data-sm-closed')) {
      originalAttributes.set(element, Object.assign(Object.fromEntries(trackedAttributes.map(name => [name,element.getAttribute(name)])),{hadClosedClass:element.classList.contains('sm-is-closed')}));
      element.setAttribute('data-sm-closed', '');
      element.setAttribute('data-sm-closed-label', config.label || 'Closed');
      element.classList.add('sm-is-closed');
      element.title = (config.label || 'Closed') + ' — Homepage';
      element.setAttribute('aria-label', element.textContent.trim() + ' — ' + (config.label || 'Closed') + '. Homepage');
      if (element.hasAttribute('aria-expanded')) element.setAttribute('aria-expanded', 'false');
      if (element.tagName === 'A') element.dataset.smClosureOriginalHref = element.getAttribute('href') || '';
    }
    if (element.tagName === 'A') {
      if (element.getAttribute('href') !== home.pathname) element.setAttribute('href', home.pathname);
      element.removeAttribute('target');
      element.removeAttribute('download');
    }
    return true;
  };
  const candidates = 'a,button,[role="button"],[role="tab"]';
  const intercept = event => {
    const element = event.target instanceof Element && event.target.closest(candidates);
    if (!element || !mark(element)) return;
    event.stopImmediatePropagation();
    if (element.tagName !== 'A' || event.type === 'keydown') {
      event.preventDefault();
      location.assign(home.href);
    }
  };
  document.addEventListener('click', intercept, true);
  document.addEventListener('auxclick', intercept, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') intercept(event);
  }, true);
  const scan = root => {
    if (root instanceof Element && root.matches(candidates)) mark(root);
    root.querySelectorAll(candidates).forEach(mark);
  };
  let availabilityTimer, checkingAvailability = false, failures = 0;
  const closeBlackbookPanels = () => {
    document.querySelectorAll('[data-sm-home-blackbook]').forEach(tab => {
      tab.classList.remove('is-open');
      const toggle = tab.querySelector('.sm-home-blackbook-toggle');
      const panel = tab.querySelector('#sm-home-blackbook-panel');
      if (toggle) { toggle.setAttribute('aria-expanded','false'); const icon=toggle.querySelector('em'); if(icon) icon.textContent='+'; }
      if (panel) panel.hidden=true;
    });
    const map=document.querySelector('[data-sm-world-live].sm-bb-active');
    if (map) map.querySelector('.sm-bb-map__tabs button')?.click();
  };
  const setBlackbookAvailable = available => {
    if (!available && !closed.blackbook) closeBlackbookPanels();
    closed.blackbook = !available;
    document.documentElement.dataset.smBlackbookAvailability = available ? 'online' : 'offline';
    scan(document);
    document.dispatchEvent(new CustomEvent('sm:blackbook-availability',{detail:{available}}));
    if (!available && blackbookURL(new URL(location.href))) location.replace(home.href);
  };
  const checkBlackbook = async () => {
    clearTimeout(availabilityTimer);
    if (document.hidden || checkingAvailability) return;
    checkingAvailability = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(),15000);
    try {
      const response = await fetch('https://stylemechanics-community-production.up.railway.app/stats',{mode:'cors',credentials:'omit',cache:'no-store',signal:controller.signal});
      if (!response.ok) throw new Error('Black Book unavailable');
      const data = await response.json();
      if (data.total_approved == null || !Number.isFinite(Number(data.total_approved))) throw new Error('Invalid Black Book response');
      failures = 0;
      setBlackbookAvailable(true);
    } catch (_) {
      if (!document.hidden && ++failures >= 2) setBlackbookAvailable(false);
    } finally {
      clearTimeout(timeout);
      checkingAvailability = false;
      if (!document.hidden) availabilityTimer = setTimeout(checkBlackbook,failures === 1 ? 5000 : 30000);
    }
  };
  const start = () => {
    scan(document);
    if (automaticBlackbook) {
      document.documentElement.dataset.smBlackbookAvailability='checking';
      checkBlackbook();
      document.addEventListener('visibilitychange',() => {clearTimeout(availabilityTimer);if(!document.hidden)checkBlackbook();});
    }
    const pending = new Set();
    let scheduled = false;
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') pending.add(record.target);
        for (const node of record.addedNodes) if (node instanceof Element) pending.add(node);
      }
      if (!pending.size || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        const nodes = Array.from(pending); pending.clear();
        nodes.forEach(node => { if (node.isConnected) scan(node); });
      });
    }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['href']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

